import { TFunction } from 'react-i18next';
import KeysDateRange from '../../../../_Translations/generated/date-range-input.en.t.json.keys';
import dayjs from 'dayjs';
import { ConfigModel } from '@ibe/services';

const NUMBER_DAY_PER_WEEK = 7;

export type Mode = 'selectsStart' | 'selectsEnd' | 'none';
export type DefaultDate = {
  startDate?: string;
  endDate?: string;
};

export const durationToString = (tDateRange: TFunction, duration?: number) => {
  if (!duration) return '';
  const rest = duration % NUMBER_DAY_PER_WEEK;
  const numberOfWeeks = duration / NUMBER_DAY_PER_WEEK;
  if (rest || !numberOfWeeks)
    return tDateRange(KeysDateRange.nights, { count: duration, numberOfNights: duration });
  return tDateRange(KeysDateRange.weeks, { count: numberOfWeeks, numberOfWeeks });
};

export const dateToString = (date: string, config: ConfigModel): string => {
  return dayjs(date).format(config.formatDate.toUpperCase());
};

export const getMinDate = (
  mode: Mode,
  startDate?: Date,
  minDate?: string,
  defaultDate?: DefaultDate
): Date | undefined => {
  const tomorrow = dayjs(new Date()).add(1, 'day');
  return mode === 'selectsEnd' && !!startDate
    ? dayjs(startDate).toDate()
    : mode === 'selectsStart'
    ? !!minDate && dayjs(minDate).isAfter(tomorrow)
      ? dayjs(minDate).toDate()
      : defaultDate?.startDate
      ? dayjs(defaultDate?.startDate).toDate()
      : tomorrow.toDate()
    : defaultDate?.startDate && dayjs(defaultDate?.startDate).isAfter(tomorrow)
    ? dayjs(defaultDate?.startDate).toDate()
    : undefined;
};

export const getExcludedDaysInCurrentMonth = (
  currentMonth: number,
  currentYear: number,
  mode: Mode,
  startDate?: Date,
  localDuration?: number,
  minDate?: string,
  defaultDate?: DefaultDate
) => {
  const monthYearInPastMonth = `${currentMonth === 0 ? currentYear - 1 : currentYear}-${
    currentMonth === 0 ? 11 : currentMonth
  }`;
  const monthYearInFutureMonth = `${currentMonth === 11 ? currentYear + 1 : currentYear}-${
    currentMonth === 11 ? 1 : currentMonth + 2
  }`;
  const daysInPastMonth = dayjs(`${monthYearInPastMonth}-01`)?.daysInMonth();
  const daysInFutureMonth = dayjs(`${monthYearInFutureMonth}-01`)?.daysInMonth();
  if (!!daysInPastMonth && !!daysInFutureMonth) {
    let excludedDays = [
      ...[...Array(7).keys()].map(key =>
        dayjs(`${monthYearInPastMonth}-${daysInPastMonth - key}`).toDate()
      ),
      ...[...Array(7).keys()].map(key => dayjs(`${monthYearInFutureMonth}-${1 + key}`).toDate())
    ];
    if (
      mode === 'selectsEnd' &&
      !!startDate &&
      !!localDuration &&
      (!getMinDate(mode, startDate, minDate, defaultDate) ||
        (!!getMinDate(mode, startDate, minDate, defaultDate) &&
          dayjs(startDate)
            .add(localDuration, 'days')
            .isAfter(dayjs(getMinDate(mode, startDate, minDate, defaultDate)))))
    ) {
      excludedDays = [
        ...excludedDays,
        ...[...Array(localDuration - 1).keys()].map(key =>
          dayjs(startDate)
            .add(key + 1, 'day')
            .toDate()
        )
      ];
    }
    return excludedDays;
  } else {
    return [];
  }
};
